<template>
  <div id="">
    <div v-if="!show_videos" class="container mt-4">
      <div id="data-list-list-view" class="data-list-container b-card p-4">
        <h4 class="mt-4">
          Select any video below to analyse
        </h4>
        <vs-table ref="table" v-model="selected_video" pagination :max-items="itemsPerPage" search :data="all_videos">
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="flex flex-wrap-reverse items-center data-list-btn-container" />

            <!-- ITEMS PER PAGE -->
            <b-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer d-flex justify-content-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                  {{
                    all_videos.length - currentPage * itemsPerPage > 0
                      ? currentPage * itemsPerPage
                      : all_videos.length
                  }}
                  of {{ queriedItems }}</span>
                <feather-icon icon="ChevronDownIcon" svg-classes="h-4 w-4" />
              </div>
              <!-- <b-button class="btn-drop" type="line" variant="primary" icon-pack="feather" icon="icon-chevron-down"></b-button> -->
              <b-dropdown-menu>
                <b-dropdown-item @click="itemsPerPage = 10">
                  <span>10</span>
                </b-dropdown-item>
                <b-dropdown-item @click="itemsPerPage = 20">
                  <span>20</span>
                </b-dropdown-item>
                <b-dropdown-item @click="itemsPerPage = 30">
                  <span>30</span>
                </b-dropdown-item>
                <b-dropdown-item @click="itemsPerPage = 50">
                  <span>50</span>
                </b-dropdown-item>
              </b-dropdown-menu>
            </b-dropdown>
          </div>

          <template slot="thead">
            <vs-th sort-key="booking_id">
              Video ID
            </vs-th>
            <vs-th sort-key="position">
              Event Position
            </vs-th>
            <vs-th sort-key="date">
              Date
            </vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr v-for="(tr, indextr) in data" :key="indextr" :data="tr">
                <vs-td>
                  <p class="font-medium truncate">
                    {{ tr.booking_id }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">
                    {{ tr.position }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">
                    {{ tr.date }}
                  </p>
                </vs-td>

                <vs-td>
                  <b-button variant="warning" type="filled" @click="getRecording(tr.filename)">View more</b-button>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </div>
    <b-card v-else class="">
      <b-button variant="warning" type="filled" @click="getBack()">Go Back</b-button>
      <!-- <div class="vx-row mx-auto mb-4 mt-2">
        <h2 class="mx-auto">
          Attention
        </h2>
        <b-progress :height="14" :percent="attention" variant="warning">Attention</b-progress>
      </div> -->
      <div class="vx-row">
        <div class="vx-col md:w-1/5">
          <div class="vx-row m-2">
            <h3>Sentiment Summary</h3>
          </div>
          <hr>
          <!-- <div class="vx-row ml-2 mt-6">
            <h5>Overall conversation : Positive</h5>
          </div>
          <div class="vx-row ml-2 mt-6">
            <h5>Overall emotion : {{ emotion_data }}</h5>
          </div>
          <div class="vx-row ml-2 mt-6">
            <h5>Overall valence : {{ valence }}</h5>
          </div>

          <div class="vx-row ml-2 mt-6">
            <h5>Overall attention span : {{ overall_attention }}%</h5>
          </div>
          <div class="vx-row ml-2 mt-6">
            <h5>Likely age: {{ likely_age }} yrs</h5>
          </div> -->
        </div>
        <div class="vx-col md:w-3/5">
          <video id="yt_player" width="800" height="500" data-v-33bf0814="" playsinline="" preload="auto"
            controls="controls" disablepictureinpicture="" controlslist="nodownload nofullscreen" muted="unmuted"
            loop="loop" crossorigin="Anonymous" :src="video_link" />
          <!-- <video-player
            id="video_player"
            ref="videoPlayer"
            :playsinline="true"
            class="card-video"
            :options="playerOptions"
          /> -->
        </div>
        <div class="vx-col md:w-1/5">
          <div class="vx-row m-2">
            <h3>Emotion Analysis</h3>
          </div>
          <hr>
          <div v-if="emotion_loading === false" class="card-container">
            <div v-for="emotion in emotion_data" :key="emotion.name" class="emotion-card">
              <div class="emotion-name">{{ emotion.name }}</div>
              <div class="emotion-score">{{ (emotion.score * 100).toFixed(1) }}%</div>
            </div>
          </div>
          <div v-else class="card-container">
            <div class="emotion-card">
              <div class="emotion-name">Loading...</div>
              <div class="emotion-spinner"></div>
            </div>
          </div>
        </div>

      </div>
      <div class="vx-row mt-4">
        <div class="vx-col md:w-1/5" />
        <div class="vx-col md:w-3/5">
          <textarea id="" class="mx-auto text-xl" name="" cols="78" rows="4" placeholder="Closed Captions" />
        </div>
        <div class="vx-col md:w-1/5" />
      </div>
    </b-card>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'

import { videoPlayer } from 'vue-video-player'
import {
  BCard,
  BFormGroup,
  BFormInput,
  BButton,
  BRow,
  BCol,
  BInputGroup,
  BInputGroupAppend,
  BModal,
  VBModal,
  BBadge,
  BAvatar,
  BOverlay,
  BFormCheckbox,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BButton,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BModal,
    VBModal,
    BBadge,
    BAvatar,
    BOverlay,
    BFormCheckbox,
    BFormInvalidFeedback,
    videoPlayer,
  },

  data() {
    return {
      show_videos: true,
      all_videos: [],
      selected_video: '',
      overall_attention: 0,
      overall_emotion: 'Calculating..',
      valence: 'Calculating..',
      likely_age: 0,
      total_attention: [],
      emotion_loading: true,
      emotion_data: '',
      // emotion_data: [{ "name": "Tiredness", "score": 0.5671913628257922 }, { "name": "Calmness", "score": 0.39939376355996775 }, { "name": "Disappointment", "score": 0.38397228006106704 }, { "name": "Boredom", "score": 0.3698303583842605 }, { "name": "Sadness", "score": 0.35037813791588174 }],
      emotion: {
        happy: 0,
        fear: 0,
        disgust: 0,
        sad: 0,
        surprise: 0,
        angry: 0,
        neutral: 0,
      },
      attention: 0,
      morphCast: undefined,
      video_active: true,
      video_link: '',
      itemsPerPage: 4,
      products: [],
      isMounted: false,
      playerOptions: {
        // videojs options
        crossOrigin: 'Anonymous',
        controls: true,
        liveui: true,
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0, 2.5, 3.0],
        width: 800,
        height: 500,
        sources: [
          {
            type: 'video/mp4',
            src: '',
            // src: this.$http.defaults.baseURL + "/api/media/interview_place.mp4",
          },
        ],
        // poster: "https://goo.gl/xcCsDd",
        isLoading: true,
      },

    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.all_videos.length
    },
  },
  async created() {
    this.video_link = await this.$generateDownloadUrl('media/interview_sample.mp4')
    this.playerOptions.sources = [
      {
        type: 'video/mp4',
        // src: await this.$generateDownloadUrl('media/interview_tips.mp4'),
        src: this.video_link,
        // src: this.$http.defaults.baseURL + "/api/media/interview_place.mp4",
      },
    ]
    const { user_group } = this.$store.state.auth.ActiveUser
    this.get_all_videos()
  },
  mounted() {
    console.log('mounted')
    this.detect_emotion()
    if (!this.show_videos) {
      // this.loadAnalyzer()
    }
  },
  methods: {
    getBack() {
      this.show_videos = true
    },
    getRecording(filename) {
      this.loadAnalyzer()
      const url = `${this.$http.defaults.baseURL}/api/recordings/`
      // let url = "http://localhost:81/api/recordings/"
      // this.video_link = url + filename;
      this.show_videos = false
    },
    get_all_videos() {
      this.isLoading = true
      this.$http
        .get('/api/get_recordings')
        .then(response => {
          this.all_videos = response.data.output
          this.isLoading = false
        })
        .catch(error => { })
    },
    detect_video() {
      try {
        CY.loader()
          .licenseKey('f557157399652b4555239c78e7aa4b57e758f4bdd367')
          .addModule(CY.modules().FACE_DETECTOR.name)
          .load()
          .then(({ start, stop }) => start())

        window.addEventListener(CY.modules().FACE_DETECTOR.eventName, evt => {
          // console.log("Face detector result", evt.detail);
        })
      } catch (error) { }
    },
    loadAnalyzer() {
      const morphScript = document.createElement('script')
      // let player = this.$refs.videoPlayer.player;
      Number.prototype.round = function (places) {
        return +`${Math.round(`${this}e+${places}`)}e-${places}`
      }
      morphScript.setAttribute(
        'src',
        'https://ai-sdk.morphcast.com/v1.14/ai-sdk.js',
      )
      morphScript.onload = () => {
        // player.tech_.el_.setAttribute("crossorigin", "anonymous");
        this.morphCast = CY
        const customSource = CY.createSource.fromVideoElement(
          document.getElementById('yt_player'),
        )
        const config = { smoothness: 0.4, enableBalancer: false }
        this.morphCast
          .loader()
          .licenseKey('insert-here-your-license-key')
          .source(customSource)
          .addModule(CY.modules().FACE_AGE.name, {})
          .addModule(CY.modules().FACE_EMOTION.name, config)
          .addModule(CY.modules().FACE_AROUSAL_VALENCE.name, {
            smoothness: 0.7,
          })
          .addModule(CY.modules().FACE_ATTENTION.name, { smoothness: 0.83 })
          .load()
          .then(({ start }) => {
            start()
          })

        window.addEventListener(CY.modules().FACE_AGE.eventName, evt => {
          this.likely_age = evt.detail.output.numericAge
        })
        window.addEventListener(CY.modules().FACE_EMOTION.eventName, evt => {
          const { emotion } = evt.detail.output
          this.emotion = {
            angry: (emotion.Angry * 100).round(2),
            disgust: (emotion.Disgust * 100).round(2),
            surprise: (emotion.Surprise * 100).round(2),
            sad: (emotion.Sad * 100).round(2),
            happy: (emotion.Happy * 100).round(2),
            fear: (emotion.Fear * 100).round(2),
            neutral: (emotion.Neutral * 100).round(2),
          }
          // console.log(evt.detail.output);
          this.overall_emotion = evt.detail.output.dominantEmotion
        })

        window.addEventListener(CY.modules().FACE_ATTENTION.eventName, evt => {
          // console.log(evt.detail.output.attention);
          this.attention = (evt.detail.output.attention * 100).round(2)
          this.total_attention.push(this.attention)
          const average = list => list.reduce((prev, curr) => prev + curr) / list.length
          this.overall_attention = average(this.total_attention).round(2)
        })
        window.addEventListener(
          CY.modules().FACE_AROUSAL_VALENCE.eventName,
          evt => {
            const valence = evt.detail.output.arousalvalence
            if (valence > 0) {
              this.valence = 'Positive'
            } else {
              this.valence = 'Negative'
            }
          },
        )
      }

      document.head.appendChild(morphScript)
    },
    async detect_emotion() {
      const link = await this.$generateDownloadUrl('media/interview_sample.mp4')
      const encoded_link = encodeURIComponent(link)

      this.$http
        .get('/api/get-emotion-from-video?url=' + encoded_link)
        .then(response => {
          const res = response.data.top_emotions;
          this.emotion_loading = false;
          this.emotion_data = res;
        })
        .catch(error => {
          console.log(error)
        });
    },
  },
}
</script>
<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.card-container {
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
  overflow-x: auto;
  padding: 10px 0;
}

.emotion-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 110px;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  transition: transform 0.2s, box-shadow 0.2s;
}

.emotion-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}

.emotion-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.emotion-score {
  font-size: 22px;
  color: #4a86e8;
  font-weight: bold;
}

.emotion-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-left-color: #4a86e8;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
